export default {
    SET_ACCOUNT_BALANCE_HISTORIES: (state, accountBalanceHistories) => {
        state.accountBalanceHistories = accountBalanceHistories
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    RESET_ACCOUNT_BALANCE_HISTORIES: (state) => {
        state.filters = {
            leader: null,
            business: null,
            fromDate: new Date(+new Date() - 604800000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0]
        }
    }
}
